var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#466dec;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.45,62.12A20.77,20.77,0,1,0,45.4,40.48a23.93,23.93,0,0,0-6.91-4.79,16.69,16.69,0,1,0-22.14-.75A23.89,23.89,0,0,0,.5,57.41a3,3,0,0,0,6,0A17.88,17.88,0,0,1,24.36,39.55h4.25a17.77,17.77,0,0,1,13.54,6.24,3,3,0,0,0,2.28,1.05l.26,0A20.76,20.76,0,0,0,52.26,62,30.14,30.14,0,0,0,30.82,90.83a3,3,0,0,0,6,0,24.13,24.13,0,0,1,24.1-24.1H69.4a24.13,24.13,0,0,1,24.1,24.1,3,3,0,0,0,6,0A30.17,30.17,0,0,0,78.45,62.12ZM27.83,12.17A10.69,10.69,0,1,1,17.15,22.86,10.7,10.7,0,0,1,27.83,12.17ZM50.65,45.94A14.79,14.79,0,1,1,65.43,60.73,14.8,14.8,0,0,1,50.65,45.94Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/Teams.aea79b7e0b5d8190ba5e7e006033c8ee.svg";
export { ForwardRef as ReactComponent };